module.exports = {
	"name": "pdgclient",
	"version": "0.1.26",
	"private": true,
	"jest": {
		"collectCoverage": true
	},
	"dependencies": {
		"archiver": "^1.3.0",
		"axios": "^0.18.0",
		"eslint-plugin-flowtype": "^2.49.3",
		"eslint-plugin-import": "^2.12.0",
		"eslint-plugin-jsx-a11y": "^2.2.3",
		"eslint-plugin-react": "^6.10.3",
		"fuse.js": "^3.0.5",
		"install": "^0.10.1",
		"intercept-stdout": "^0.1.2",
		"iscroll": "^5.2.0",
		"jquery": "^3.3.1",
		"md5-file": "^3.2.3",
		"moment": "^2.22.1",
		"node-sass": "^4.11.0",
		"npm": "^4.5.0",
		"prop-types": "^15.6.1",
		"quill-delta-to-html": "^0.9.6",
		"react": "^15.6.1",
		"react-dom": "^15.6.1",
		"react-fontawesome": "^1.6.1",
		"react-icons": "^2.2.5",
		"react-iscroll": "^1.1.4",
		"react-lazyload": "^2.3.0",
		"react-moment": "^0.7.0",
		"react-player": "^1.5.0",
		"react-redux": "^5.0.5",
		"react-router": "^4.1.1",
		"react-router-dom": "^4.1.1",
		"react-slick": "^0.14.11",
		"react-transition-group": "^1.1.3",
		"redux": "^3.7.2",
		"redux-thunk": "^2.2.0",
		"rimraf": "^2.6.2",
		"sails.io.js": "^1.1.13",
		"serve": "^5.2.2",
		"signale": "^1.2.1",
		"simple-git": "^1.95.0",
		"socket.io-client": "^1.7.4",
		"source-map": "^0.6.1",
		"superagent": "^3.5.2",
		"video-react": "^0.8.6",
		"whatwg-fetch": "^2.0.3",
		"winston": "^2.4.0",
		"winston-papertrail": "^1.0.5",
		"electron": "^4.1.4"
	},
	"devDependencies": {
		"enzyme": "^3.3.0",
		"enzyme-adapter-react-15": "^1.0.5",
		"react-scripts": "0.9.5",
		"react-test-renderer": "^15.6.1"
	},
	"main": "src/electronHandler.js",
	"scripts": {
		"dev-server": "react-scripts start",
		"build": "node ./scripts/removeSymlinks.js && react-scripts build && node ./scripts/createSymlinks.js",
		"test": "react-scripts test --env=jsdom --coverage --colors",
		"eject": "react-scripts eject",
		"start": "./node_modules/.bin/serve -s build -c 3500 -p 3002 &",
		"get-data": " node scripts/updateFiles.js -- isnpm -- md5",
		"get-data-force": " node scripts/updateFiles.js -- isnpm -- md5 -- clearjson",
		"get-data-only": " node scripts/updateFiles.js -- isnpm -- skipfiles -- clearjson",
		"setup-project": "node scripts/setupProject.js",
		"electron": "electron .",
		"watch-sass": "./node_modules/.bin/node-sass --watch src/style/scss --output src/style"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 175
// module chunks = 0